import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { isWeddingContext } from './weddingHost'

const root = createRoot(document.getElementById('root')!);

if (isWeddingContext()) {
  // Wedding sub-site (attend.nu or legacy /bröllop path): load only the
  // wedding bundle — no Brickn editor, no three.js, no MUI.
  import('./WeddingApp').then(({ default: WeddingApp }) => {
    root.render(
      <StrictMode>
        <WeddingApp />
      </StrictMode>,
    );
  });
} else {
  // Brickn app. Everything is lazy so the wedding domain never pays for it.
  Promise.all([
    import('./AppRouter'),
    import('@mui/material/styles'),
    import('./Utils/indexedDBStorage'),
  ]).then(([{ default: AppRouter }, { ThemeProvider, createTheme }, { indexedDBStorage }]) => {
    if (typeof window !== 'undefined') {
      (window as unknown as Window & { indexedDBStorage: typeof indexedDBStorage }).indexedDBStorage = indexedDBStorage;
    }
    const theme = createTheme({
      components: {
        MuiDialog: {
          defaultProps: {
            disableEnforceFocus: true,
            disableAutoFocus: true,
            disableRestoreFocus: true,
          },
        },
      },
    });
    root.render(
      <StrictMode>
        <ThemeProvider theme={theme}>
          <AppRouter />
        </ThemeProvider>
      </StrictMode>,
    );
  });
}

